/*
// Esempio di funzione da aggiungere ai tuoi servizi API
export const updateBookingTicket = async (bookingId: number, ticketNumber: string, isSent: boolean) => {
    const response = await fetch(`/api/bookings/${bookingId}/ticket`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ticketNumber, isSent }),
    });
    if (!response.ok) throw new Error("Errore durante il salvataggio del ticket");
    return await response.json();
};
*/

import { Call } from "../../../api/apiCall";
import { BASE_URL_API } from "../../../api/config";

export const insertBookingTicket = async (externalActivityId: string | number, ticketNumber: string, ticketIsSentToCustomer: boolean, pdfLink: string, audioGuideLink: string, ticketLanguage: string, userId: string): Promise<boolean> => {
    try {
        const payload = {
            ExternalActivityId: externalActivityId,
            ticketNumber: ticketNumber,
            ticketIsSentToCustomer: ticketIsSentToCustomer,
            pdfLink: pdfLink,
            audioGuideLink: audioGuideLink, // Se non hai un link per l'audio guida, puoi lasciarlo vuoto o rimuovere questa proprietà se il backend lo consente
            ticketLanguage: ticketLanguage, // Aggiunta del campo per la lingua del biglietto
            UserId: userId,
        };

        const res = await Call("bookings/setBookingTicketNumber", "post", payload); 

        // 1. Leggiamo il corpo della risposta UNA sola volta
        const data = await res.json();

        if (res.ok) {
            // Se il backend restituisce { success: true } o direttamente 1/0
            // Verifichiamo la proprietà 'success' o il valore restituito
            const isSuccessful = data.success === true || data === true || data === 1;
            if (!isSuccessful) {
                throw new Error(data.message || "Il server non ha confermato il salvataggio del ticket.");
            }
            return true;
        } else {
            // Se res.ok è false, data conterrà i dettagli dell'errore inviati dal server
            console.error("Errore API lato server:", data);
            throw new Error(data.message || `Errore server: ${res.status}`);
        }
    } catch (error) {
        // Gestione degli errori di rete o crash del JSON parse
        console.error("Errore di comunicazione:", error);
        throw new Error(error instanceof Error ? error.message : "Errore di connessione al server.");
    }
};

/**
 * Carica un file PDF sul server e restituisce l'URL pubblico generato.
 * @param file Il file PDF selezionato dall'utente
 * @param externalActivityId ID della prenotazione (per il nome file)
 * @returns URL pubblico del PDF caricato
 */
export const uploadTicketPdf = async (file: File, externalActivityId?: string | number | null, prefix?: string): Promise<string> => {
    const token = localStorage.getItem("authToken");
    if (!token) {
        throw new Error("Sessione scaduta. Effettua nuovamente il login.");
    }

    const uri = `${BASE_URL_API}bookings/uploadTicketPdf`;

    const headers: HeadersInit = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/pdf",
        "X-External-Activity-Id": String(externalActivityId ?? "upload"),
    };

    if (prefix) {
        (headers as Record<string, string>)["X-Filename-Prefix"] = prefix;
    }

    const response = await fetch(uri, {
        method: "POST",
        headers,
        body: file,
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: "Errore durante l'upload." }));
        throw new Error(errorData.error || `Errore server: ${response.status}`);
    }

    const data = await response.json();
    return data.url;
};
